import { getDisplayCapeTokenAddress, getExplorerAddressUrl, shortAddress } from "../utils/launchLinks";
import { TOTAL_SUPPLY_CAP } from "../utils/config";

const ALLOCATIONS = [
  {
    pct: "50%",
    amount: "10,500,000 CAPE max",
    title: "NFT base burn-claim allocation",
    body: "At finalize, M minted Apes activate M x 5,000 CAPE for burn claims. Each burned NFT claims 5,000 CAPE base; at the initial LP ratio, that maps to 0.005 ETH before market movement. Unminted claim allocation is burned."
  },
  {
    pct: "40%",
    amount: "8,400,000 CAPE max",
    title: "Community LP allocation",
    body: "At finalize, M minted Apes route M x 4,000 CAPE plus mint ETH into the official v4 LP. Unminted LP allocation is burned, then the LP locks into UNCX before trading opens. After the 90-day unlock, unburned NFTs can claim split v4 LP positions and directly own that liquidity."
  },
  {
    pct: "10%",
    amount: "2,100,000 CAPE max",
    title: "Dynamic NFT bonus pool",
    body: `If sold out, ${TOTAL_SUPPLY_CAP.toLocaleString()} x 1,000 CAPE funds this pool. If finalize happens before sell-out, only M x 1,000 CAPE activates and the rest is burned. It is paid only through burnToClaim as min(remainingBonus / activeNFTCount, 5,000 CAPE), on top of the 5,000 CAPE base.`
  }
];

export default function TokenomicsDiagram() {
  const capeTokenAddress = getDisplayCapeTokenAddress();
  const capeExplorerUrl = capeTokenAddress ? getExplorerAddressUrl(capeTokenAddress) : null;

  async function copyCapeTokenAddress() {
    if (!capeTokenAddress) return;
    await navigator.clipboard?.writeText(capeTokenAddress);
  }

  return (
    <section className="tokenomics card" aria-labelledby="tokenomics-title">
      <div className="tokenomics__copy">
        <div className="badge badge-prime" style={{ marginBottom: "var(--space-3)" }}>Tokenomics</div>
        <h2 id="tokenomics-title" className="text-4xl">21M CAPE supply map</h2>
        <p className="text-muted tokenomics__lede">
          CAPE is split between NFT burn claims, launch liquidity, and a dynamic NFT bonus pool. M means the number of NFTs minted when finalize runs at sell-out or after the mint deadline. Holding an active NFT also earns from the WETH hook-fee stream, which is separate from the CAPE supply allocation.
        </p>
        {capeTokenAddress && capeExplorerUrl ? (
          <div className="tokenomics__contract" aria-label="CAPE token contract address">
            <span>CAPE token contract</span>
            <a href={capeExplorerUrl} target="_blank" rel="noreferrer"><code>{shortAddress(capeTokenAddress)}</code></a>
            <button type="button" onClick={copyCapeTokenAddress}>Copy</button>
          </div>
        ) : null}
      </div>

      <div className="tokenomics__visual" aria-label="CAPE supply allocation diagram">
        <div className="tokenomics__ring" aria-hidden="true">
          <span className="tokenomics__ring-center">
            <strong>21M</strong>
            <small>$CAPE</small>
          </span>
        </div>
        <div className="tokenomics__legend">
          {ALLOCATIONS.map((item) => (
            <div key={item.title} className="tokenomics__allocation">
              <div className="tokenomics__pct">{item.pct}</div>
              <div>
                <strong>{item.title}</strong>
                <span>{item.amount}</span>
                <p>{item.body}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="tokenomics__flow" aria-label="Holder fee stream">
        <div className="tokenomics__node tokenomics__node--pool">
          <strong>Official v4 pool swaps</strong>
          <span>both directions; real trades only</span>
        </div>
        <div className="tokenomics__arrow" aria-hidden="true">→</div>
        <div className="tokenomics__node tokenomics__node--fee">
          <strong>1% WETH hook fee</strong>
          <span>collected by CodeApeHook</span>
        </div>
        <div className="tokenomics__arrow" aria-hidden="true">→</div>
        <div className="tokenomics__node tokenomics__node--holders">
          <strong>Active NFT holders</strong>
          <span>share trading fees together; hold for fee flow or burn later for CAPE</span>
        </div>
      </div>

      <aside className="not-staking" aria-label="Not staking clarification">
        <span className="eyebrow">// not staking</span>
        <p>
          The WETH fee stream above is not APY on locked capital. It is a Uniswap v4 hook routing trading fees to active NFT holders. The game is simple: hold to keep fees and LP optionality; burn to take CAPE and leave future fees and unclaimed LP behind.
        </p>
      </aside>
    </section>
  );
}
